const adminPages = [
  "/overview",
  "/admin",
  "/users",
  "/reports",
  "/adduser",
  "/accessmanagement",
  "/myaccount",
];
export const isAdminPath = (pathname) => {
  return adminPages.some((page) => pathname.startsWith(page));
};
